import type {
  ButtonConfig,
  CustomComponentConfig,
  DropdownConfig,
  ExportConfig,
  SettingsConfig,
  ToggleConfig,
  DividerConfig,
} from './types';
import { SettingsType } from './types';

export const isToggleConfig = (
  config: SettingsConfig
): config is ToggleConfig => config.type === SettingsType.TOGGLE;

export const isButtonConfig = (
  config: SettingsConfig
): config is ButtonConfig => config.type === SettingsType.BUTTON;

export const isExportConfig = (
  config: SettingsConfig
): config is ExportConfig => config.type === SettingsType.EXPORT;
export const isDropdownConfig = (
  config: SettingsConfig
): config is DropdownConfig => config.type === SettingsType.DROPDOWN;
export const isCustomComponentConfig = (
  config: SettingsConfig
): config is CustomComponentConfig =>
  config.type === SettingsType.CUSTOM_COMPONENT;
export const isDividerConfig = (
  config: SettingsConfig
): config is DividerConfig => config.type === SettingsType.DIVIDER;
